import omnivore from '../vendor/leaflet-omnivore.js';

const loadKml = (path, fillOpacity = 0.2, stroke = true) => {
  const kmlLayer = omnivore.kml(path)
    .on('ready', () => {
      kmlLayer.eachLayer((layer) => {
        // full list of option: https://leafletjs.com/reference.html#path-option
        layer.setStyle({
          color: layer.feature.properties.Hexcolor,
          weight: 4,
          stroke,
          fillOpacity,
        });
      });
    });

  return kmlLayer;
}

export default loadKml;